// extracted by mini-css-extract-plugin
export default {"MarginLeftCard":"CardXl_MarginLeftCard__aQ5VQ","modal":"CardXl_modal__FpkhA"};